module.exports = __webpack_public_path__ + "img/paintedfingerclue.b234338b.png";